style= require('./event-selector.styl')
.events
  each event, $index in sortedEvents
    .event(
      (click)=this.select(event),
      class=this.eventClass(event)
    )
      .shortcut (#{shortcuts[$index]})
      ft-icon.default-col(no-warning=true, name=eventIcon(event))
      .name= this.eventName(event)

